export interface ReportValidationResult {
  canPrint: boolean;
  isComplete: boolean;
  errors: string[];
  warnings: string[];
}

export function validateReportForPrinting(report: any, equipment?: any, checklist?: any[]): ReportValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];

  // 1. Verificação de Dados Básicos / TAG
  const tag = equipment?.tag || report?.equipmentTag || report?.tag || '';
  if (!tag || tag.trim() === '') {
    warnings.push('Identificação do Equipamento / TAG não informada (Relatório em branco)');
  }

  // 2. Verificação de Tipo de Inspeção
  const inspectionType = report?.inspectionType || report?.type || '';
  if (!inspectionType || inspectionType.trim() === '') {
    warnings.push('Tipo de Inspeção não especificado');
  }

  // 3. Verificação de Conclusão Técnica
  const conclusion = report?.conclusion || report?.conclusionText || '';
  if (!conclusion || conclusion.trim() === '' || conclusion.trim().length < 10) {
    warnings.push('Parecer Técnico Conclusivo não preenchido ou incompleto');
  }

  // 4. Verificação de Inspeção Visual / Observações
  const observations = report?.inspectionObservations || report?.notes || '';
  const hasChecklist = Array.isArray(checklist) && checklist.length > 0;
  if (!observations && !hasChecklist) {
    warnings.push('Constatações da Inspeção Visual / Checklist não preenchidos');
  }
  
  // Verificação de Pendências do Checklist Técnico
  if (Array.isArray(checklist)) {
    const pendingItems = checklist.filter(c => c.result === 'PENDING' || c.status === 'PENDING');
    if (pendingItems.length > 0) {
      errors.push(`${pendingItems.length} componente(s) no checklist técnico estão pendentes de inspeção.`);
    }
  }

  // 5. Verificação de Status e Pendências de Aprovação
  const status = report?.status || 'DRAFT';
  if (status === 'DRAFT') {
    warnings.push('Relatório em status de Rascunho (DRAFT) — Necessário submeter para análise do Engenheiro PLH');
  } else if (status === 'WAITING_PLH') {
    warnings.push('Pendente de aprovação técnica do Engenheiro PLH');
  } else if (status === 'WAITING_SIGNATURE') {
    warnings.push('Pendente de assinaturas digitais obrigatórias (Inspetor / PLH)');
  } else if (status === 'REJECTED') {
    warnings.push('Relatório reprovado pelo Engenheiro PLH — Correções pendentes');
  }

  // 6. Verificação de Assinaturas
  if (status !== 'ISSUED' && status !== 'SIGNED' && status !== 'COMPLETED' && status !== 'APPROVED') {
    if (!report?.signedByInspector && !report?.signedByPlh) {
      warnings.push('Assinaturas técnicas do Inspetor e do Engenheiro PLH não registradas');
    }
  }

  return {
    canPrint: errors.length === 0,
    isComplete: errors.length === 0 && warnings.length === 0,
    errors,
    warnings
  };
}
